import clientAxios from "../../client";

export async function analysisAnswerShow(
  account_id: string,
  answer_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/analysis/answer/${answer_id}/show`,
  );
}

export async function analysisAnswerPatch(
  account_id: string,
  answer_id: string,
  payload: any,
) {
  return await clientAxios.patch(
    `account/${account_id}/analysis/answer/${answer_id}/patch`,
    {
      payload,
    },
  );
}
